import { render, staticRenderFns } from "./VehicleInspectionAct.vue?vue&type=template&id=dc104042&"
import script from "./VehicleInspectionAct.vue?vue&type=script&lang=js&"
export * from "./VehicleInspectionAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports